interface Deal {
  id: string;
  legacyId?: number;
  name: string;
  lost: boolean;
  standBy: boolean;
  dateClosed: string;
}

interface LegacyDeal {
  id: number;
  dateCreate: string;
  deleted?: boolean;
  lost?: boolean;
  name: string;
  desiredClotureDate?: string;
  contractEndDate?: string;
  domain?: { id: number };
  origin?: { id: number; labelOrigin?: string };
  customerSatisfactionCommercialRating?: number | null;
  customerSatisfactionInstallationRating?: number | null;
  customerSatisfactionPreparationRating?: number | null;
  stepCommercial?: { intermediateStageNumber?: number; commercialEmployee?: { id: number; user?: { id: number } } };
  type?: { id: number; name: string };
  creator?: { user: { id: string; username: string } };
  customer?: {
    id?: number;
    installationSite?: {
      socialReason?: string;
      adress?: string;
      postalCode?: string;
      telOffice?: string;
    };
  };
  stepProd?: StepProduction;
  interlocutors?: Array<{
    id: number;
    name?: string;
    lastname?: string;
    email?: string;
  }>;
}

interface StepProduction {
  id: number;
  intermediateStageNumber?: number;
  preparation?: {
    installation?: Installation;
    associationsProductsHardware?: Array<{
      id: number;
      products?: Array<{
        id: number;
        installed?: boolean;
        dateInstalled?: string;
        stickerId: number;
      }>;
      quoteArticle?: QuoteArticleHardware;
    }>;
    associationsProductsVirtual?: Array<{
      id: number;
      products?: Array<{
        id: number;
        installed?: boolean;
        dateInstalled?: string;
      }>;
      quoteArticle?: QuoteArticleVirtual;
    }>;
  };
}

interface QuoteArticle<ProductReference> {
  id: number;
  quantity: number;
  commercialWording?: string;
  productReference?: ProductReference;
}

type QuoteArticleHardware = QuoteArticle<ProductReferenceHardware>;
type QuoteArticleVirtual = QuoteArticle<ProductReferenceVirtual>;

interface ProductReferenceVirtual {
  id: number;
  wording: string;
  supplierVirtual: { name: string; url?: string };
}

interface ProductReferenceHardware {
  id: number;
  wording: string;
  supplierHardware: { name: string; url?: string };
}

interface Installation {
  id: number;
  trainingSheets?: Array<{ id: number; name: string }>;
  workOrders?: Array<{ id: number; name: string }>;
  images?: Array<{ id: number; name: string }>;
}

export const StepNumbersOptions = [
  { label: 'Commercial', value: '(1,0)' },
  { label: 'Commercial - Proposition', value: '(1,1)' },
  { label: 'Commercial - BDC', value: '(1,2)' },
  { label: 'Production', value: '(2,0)' },
  { label: 'Production - Commande', value: '(2,1)' },
  { label: 'Production - Preparation', value: '(2,2)' },
  { label: 'Production - Installation', value: '(2,3)' },
  { label: 'Administratif', value: '(3,0)' },
  { label: 'Administratif - A facturer', value: '(3,1)' },
  { label: 'Administratif - Partiellement facturé', value: '(3,2)' },
  { label: 'Administratif - Facturé', value: '(4,0)' },
];

export default Deal;
export { LegacyDeal, StepProduction, QuoteArticleVirtual, QuoteArticleHardware };
